export default __webpack_public_path__ + "static/media/vididentity_logo.b3f1196d.svg";